import { NgModule } from '@angular/core';
import { IonicPageModule } from 'ionic-angular';
import { FraudsPage } from './frauds';

@NgModule({
  declarations: [
    FraudsPage,
  ],
  imports: [
    IonicPageModule.forChild(FraudsPage),
  ],
})
export class FraudsPageModule {}



// WEBPACK FOOTER //
// ./src/pages/frauds/frauds.module.ts